/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import './ww-set.scss';
import { StaticImage } from 'gatsby-plugin-image';

interface IProps {
  set: string;
}

export const WWSetMin: React.FC<IProps> = ({ set }) => {
  return (
    <>
      <div className="ww-set-min">
        <div className={`ww-set-image ${set}`}>
          {set === 'Freezing Frost' && (
            <StaticImage
              src="../../../../images/ww/icons/set_1.webp"
              alt="Set"
            />
          )}
          {set === 'Molten Rift' && (
            <StaticImage
              src="../../../../images/ww/icons/set_2.webp"
              alt="Set"
            />
          )}
          {set === 'Void Thunder' && (
            <StaticImage
              src="../../../../images/ww/icons/set_3.webp"
              alt="Set"
            />
          )}
          {set === 'Sierra Gale' && (
            <StaticImage
              src="../../../../images/ww/icons/set_4.webp"
              alt="Set"
            />
          )}
          {set === 'Celestial Light' && (
            <StaticImage
              src="../../../../images/ww/icons/set_5.webp"
              alt="Set"
            />
          )}
          {(set === 'Havoc Eclipse' || set === 'Sun-sinking Eclipse') && (
            <StaticImage
              src="../../../../images/ww/icons/set_6.webp"
              alt="Set"
            />
          )}
          {set === 'Rejuvenating Glow' && (
            <StaticImage
              src="../../../../images/ww/icons/set_7.webp"
              alt="Set"
            />
          )}
          {set === 'Moonlit Clouds' && (
            <StaticImage
              src="../../../../images/ww/icons/set_8.webp"
              alt="Set"
            />
          )}
          {(set === 'Endless Resonance' || set === 'Lingering Tunes') && (
            <StaticImage
              src="../../../../images/ww/icons/set_9.webp"
              alt="Set"
            />
          )}
          {set === 'Frosty Resolve' && (
            <StaticImage
              src="../../../../images/ww/icons/set_10.webp"
              alt="Set"
            />
          )}
          {set === 'Eternal Radiance' && (
            <StaticImage
              src="../../../../images/ww/icons/set_11.webp"
              alt="Set"
            />
          )}
          {set === 'Midnight Veil' && (
            <StaticImage
              src="../../../../images/ww/icons/set_12.webp"
              alt="Set"
            />
          )}
          {set === 'Empyrean Anthem' && (
            <StaticImage
              src="../../../../images/ww/icons/set_13.webp"
              alt="Set"
            />
          )}
          {set === 'Tidebreaking Courage' && (
            <StaticImage
              src="../../../../images/ww/icons/set_14.webp"
              alt="Set"
            />
          )}
          {set === 'Gusts of Welkin' && (
            <StaticImage
              src="../../../../images/ww/icons/set_15.webp"
              alt="Set"
            />
          )}
        </div>
        <p>
          {set === 'Endless Resonance' && 'Lingering Tunes'}
          {set === 'Sun-sinking Eclipse' && 'Havoc Eclipse'}
          {set != 'Sun-sinking Eclipse' && set != 'Endless Resonance' && set}
        </p>
      </div>
    </>
  );
};
